export class UtilityFunctions {
  private constructor() {}

  // if compare(e1, e2) === 0 then result is e1
  static max<T>(e1: T, e2: T, compare: (e1: T, e2: T) => number): T {
    if (e1 == null && e2 == null) {
      return null;
    }
    if (e1 == null) {
      return e2;
    }
    if (e2 == null) {
      return e1;
    }
    return compare(e1, e2) >= 0 ? e1 : e2;
  }

  // if compare(e1, e2) === 0 then result is e1
  static min<T>(e1: T, e2: T, compare: (e1: T, e2: T) => number): T {
    if (e1 == null && e2 == null) {
      return null;
    }
    if (e1 == null) {
      return e2;
    }
    if (e2 == null) {
      return e1;
    }
    return compare(e1, e2) <= 0 ? e1 : e2;
  }

  static nullGuardSum(n1: any, n2: any): any {
    if (n1 != null && n2 != null) {
      return Number(n1) + Number(n2);
    }
    if (n1 == null && n2 == null) {
      return null;
    }
    if (n1 != null) {
      return Number(n1);
    }
    return Number(n2);
  }

  /**
   * @returns SameValueZero(x, y) is true, see https://262.ecma-international.org/7.0/#sec-samevaluezero
   */
  static sameValueZero(x: any, y: any): boolean {
    return x === y || (Number.isNaN(x) && Number.isNaN(y));
  }

  static getProperty = <T, K extends keyof T>(object: T, key: K): T[K] =>
    object[key];
}

export type KeysOfType<T, TProp> = {
  [P in keyof T]: T[P] extends TProp ? P : never;
}[keyof T];

export type KeysEnum<T> = { [P in keyof Required<T>]: true };

type Resolved<T> = {
  value: T;
};

type PromiseContainer<T> = {
  promise: Promise<T>;
};

export type ResolvedOrPromise<T> = Resolved<T> | PromiseContainer<T>;

export function isPromise<T>(
  resolvedOrPromise: ResolvedOrPromise<T>
): resolvedOrPromise is PromiseContainer<T> {
  return Object.prototype.hasOwnProperty.call(resolvedOrPromise, 'promise');
}

export async function getValueFromResolvedOrPromise<T>(
  resolvedOrPromise: ResolvedOrPromise<T>
): Promise<T> {
  return isPromise(resolvedOrPromise)
    ? await resolvedOrPromise.promise
    : resolvedOrPromise.value;
}
